export const AppConstants = {
	appName: 'Bargain Chemist',
	brandName: 'Bargain Chemist',
	contactUrl: 'https://www.bargainchemist.co.nz/pages/contact',
	websiteUrl: 'https://www.bargainchemist.co.nz',
	pharmacyPrefix: '',
	appVersion: '1.00.00',
	emptyGuid: '00000000-0000-0000-0000-000000000000',
	searchEmptyGuid: 'ffffffff-ffff-ffff-ffff-ffffffffffff',
	sessionStorage: {
		loggedIn: 'loggedIn',
	},
	localStorage: {
	},
	ionicStorage: {
	},
	biometricStorage: {
		auth: 'biometricAuth'
	},
	defaultTimeout: 60000,
	dateMinimum: '1900-01-01',
	dateMaximum: '9999-12-31',
	mobileDeviceWidthThreshold: 1024,
	storage_lastPharmacyLinkProfile: 'lastPharmacyLinkProfile',
	scrollThreshold: 60,
	scrollThresholdDifference: 10,
	vaccinationBookingUrl: 'https://app.acuityscheduling.com/schedule/29f86d96',
	storage_biometricLoginEnabled: 'biometricLoginEnabled',
	storage_username: 'username',
	storage_settings_pendingEmailChange: 'pendingEmailChange',
	storage_profile_pendingEmailChange: 'profilePendingEmailChange'
};